import HtmlContent from '@/components/HtmlContent';
import PriceDisplay from '@/components/PriceDisplay';
import { Dialog, Typography } from '@packages/webshop-design-system';
import type { FC, ReactNode } from 'react';

interface InformationTextsModalProps {
  /** Product name shown as the modal heading */
  title: ReactNode;
  /** Price shown in the top right corner of the heading */
  amount?: number;
  /** Information texts, displayed below one another (BR-57160) */
  descriptions: Array<string>;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  'data-testid'?: string;
}

// Modal for BM-configured information texts: opened from an offer card's
// "Read more" and from the booking summary's info icon (BR-57160).
const InformationTextsModal: FC<InformationTextsModalProps> = ({
  title,
  amount,
  descriptions,
  isOpen,
  onOpenChange,
  'data-testid': testId = 'information-texts-modal',
}) => (
  <Dialog
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    data-testid={testId}
    headerTitle={
      <div className="flex w-full items-center justify-between gap-4 pr-2">
        <Typography variant="heading2">{title}</Typography>
        {amount !== undefined && (
          <Typography variant="heading2" className="text-primary">
            <PriceDisplay amount={amount} />
          </Typography>
        )}
      </div>
    }
    // The Dialog's title column shrinks to its content by default, which leaves
    // the price hugging the title; make that column grow so the inner
    // justify-between pushes the price into the top-right corner (BR-57160).
    className={{ root: 'max-w-2xl', header: '[&>div:first-child]:grow' }}
  >
    <div className="flex flex-col gap-4 text-dark">
      {descriptions.map((description, index) => (
        <HtmlContent key={index} html={description} />
      ))}
    </div>
  </Dialog>
);

export default InformationTextsModal;
